import {Requests, defaultErrorHandler} from './base'


function scoringSignatureRequest (param, $parent) {

  $parent.upload.isDisabled = true

  let signatureParam = {
    file_name: param.file_name,
    model_id: param.model_id,
    method: 'put',
    purpose: 'scoring'
  }

  return Requests.post('/scoring/signature', signatureParam)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function uploadToS3Request (preSignedURL, dataFile, $parent) {

  let uploadConfig = {headers: {'Content-Type': 'text/csv'}}

  return Requests.put(preSignedURL, dataFile, uploadConfig)
    .then(response => {
      return false
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function scoringRequest (param, $parent) {

  return Requests.post('/scoring', param)
    .then(response => {
      return response
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

function scoringTransactionRequest (transactionId, $parent) {

  return Requests.post(`/scoring/${transactionId}`, {})
    .then(response => {
      return response
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
}

export {scoringRequest, scoringTransactionRequest, scoringSignatureRequest, uploadToS3Request}



// WEBPACK FOOTER //
// ./src/modules/request/scoring.js